import Vue from 'vue'
import Router from 'vue-router'
// 一级路由
import Home from '@/Home'
const DownLoad = () => import('../view/download/index.vue')
const Login = () => import('../view/login/Login.vue')
const Register = () => import('../view/register/Register.vue')
const RetrievePassword = () => import('../view/retrievePassword/RetrievePassword.vue')
const SystemNotification = () => import('../view/systemNotification/SystemNotification.vue')
const Setting = () => import('../view/setting/Setting.vue')
const Welcome = () => import('../view/home/home.vue')
const DataScreening = () => import('../view/home/bikeanalysis/dataScreening')
const ActivateData = () => import('../view/home/bikeanalysis/activatedata')
const RealTimeMonitoring = () => import('../view/home/bikeanalysis/realTimeMonitoring')
const Usage = () => import('../view/home/bikeanalysis/usage')
const FaultStatistics = () => import('../view/home/bikeanalysis/faultStatistics')
const RegionalDistribution = () => import('../view/home/bikeanalysis/regionalDistribution')
const AppSituation = () => import('../view/home/appanalysis/appSituation')
const DataSummary = () => import('../view/home/appanalysis/dataSummary')
const Finance = () => import('../view/finance/home')
const SimCardManagement = () => import('../view/finance/simcardmanagement')
const Order = () => import('../view/finance/order')
const User = () => import('../view/usertable/home')
const ManufacturersList = () => import('../view/usertable/manufacturerusermanage/manufacturerslist')
const ManufacturerUserList = () => import('../view/usertable/manufacturerusermanage/manufactureruserlist')
const ManufacturersRoleslist = () => import('../view/usertable/manufacturerusermanage/manufacturersroleslist')
const MerchantList = () => import('../view/usertable/merchantusermanage/merchantlist')
const MerchantUserList = () => import('../view/usertable/merchantusermanage/merchantuserlist')
const MerchantRoleslist = () => import('../view/usertable/merchantusermanage/merchantroleslist')
const FranchiseesList = () => import('../view/usertable/merchantusermanage/franchiseeslist')
const FranchiseesUserList = () => import('../view/usertable/merchantusermanage/franchiseesuserlist')
const FranchiseesRolesList = () => import('../view/usertable/merchantusermanage/franchiseesroleslist')
const SystemUserList = () => import('../view/usertable/systemusermanage/systemuserlist')
const SystemRolesList = () => import('../view/usertable/systemusermanage/systemroleslist')
const PermissionRuleList = () => import('../view/usertable/systemusermanage/permissionrulelist')
const Purview = () => import('../view/usertable/systemusermanage/purview')
const Logpagelist = () => import('../view/usertable/logmanage/logpagelist')
const DemoAccountManage = () => import('../view/usertable/configurationmanage/demoAccountManagement')
const CustomerServiceConfiguration = () => import('../view/usertable/configurationmanage/customerServiceConfiguration')
const Bike = () => import('../view/biketable/home')
const BikeList = () => import('../view/biketable/bikemanage/bikelist')
const FaultManagement = () => import('../view/biketable/bikemanage/faultmanagement')
const Firmware = () => import('../view/biketable/bikemanage/firmware')
const ModelList = () => import('../view/biketable/bikemanage/modellist')
const SummaryModels = () => import('../view/biketable/bikemanage/summaryModels')
const IotList = () => import('../view/biketable/bikemanage/iotlist')
const ProductCertificate = () => import('../view/biketable/bikeriding/productCertificate')
const DebuggingReport = () => import('../view/biketable/bikeriding/debuggingReport')
const LimitedUpgradeTool = () => import('../view/biketable/bikeriding/limitedUpgradeTool')
const OATManagement = () => import('../view/biketable/bikeriding/oatManagement')
const BatchUpgrade = () => import('../view/biketable/bikeriding/batchupgrade')
const VisualReport = () => import('../view/biketable/bikeriding/visualReport')
const CyclingList = () => import('../view/biketable/cyclingmanage/cyclinglist')
const RoadBookList = () => import('../view/biketable/cyclingmanage/roadbooklist')
const Operate = () => import('../view/operate/home')
const OverviewAppListing = () => import('../view/operate/appoperate/overviewapplisting')
const OverviewAppUsers = () => import('../view/operate/appoperate/overviewappusers')
const FeedBackList = () => import('../view/operate/appoperate/feedbacklist')
const PushList = () => import('../view/operate/appoperate/pushlist')
const SysIntroduction = () => import('../view/operate/appoperate/sysintroduction')
const AppConfiguration = () => import('../view/operate/appoperate/appConfiguration')
const ElectronicFence = () => import('../view/operate/bikeoperate/electronicfence')
const Reconciliation = () => import('../view/operate/bikeoperate/reconciliation')
const TransactionRecord = () => import('../view/operate/bikeoperate/transactionRecord')
const RefundRecord = () => import('../view/operate/bikeoperate/refundRecord')
const MaintenanceRecord = () => import('../view/operate/bikeoperate/maintenanceRecord')
const SalesRecord = () => import('../view/operate/bikeoperate/salesRecord')
const NotFound = () => import('@/view/404')
// h5 页面
const ForgetPassword = () => import('../view/h5/forgetPassword')
const RegisterAccount = () => import('../view/h5/registerAccount')
const Agreement = () => import('../view/h5/agreement')
const EAgreement = () => import('../view/h5/eAgreement')
const ZAgreement = () => import('../view/h5/zAgreement')
const H5Home = () => import('../view/h5/home')
const AddSalesRecords = () => import('../view/h5/addSalesRecords')
const AddMaintenanceRecords = () => import('../view/h5/addMaintenanceRecords')
const ChangeEmail = () => import('../view/h5/changeEmail')
Vue.use(Router)
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
// 常量路由表
export const constantRoutes = [
  {
    path: '/Login',
    component: Login
  },
  {
    path: '/DownLoad',
    component: DownLoad
  },
  {
    path: '/forgetPassword',
    component: ForgetPassword
  },
  {
    path: '/registerAccount',
    component: RegisterAccount
  },
  {
    path: '/home',
    component: H5Home
  },
  {
    path: '/addSalesRecords',
    component: AddSalesRecords
  },
  {
    path: '/addMaintenanceRecords',
    component: AddMaintenanceRecords
  },
  {
    path: '/changeEmail',
    component: ChangeEmail
  },
  {
    path: '/agreement',
    component: Agreement
  },
  {
    path: '/eAgreement',
    component: EAgreement
  },
  {
    path: '/zAgreement',
    component: ZAgreement
  },
  {
    path: '/Register',
    component: Register
  },
  {
    path: '/RetrievePassword',
    component: RetrievePassword
  },
  {
    path: '*',
    component: NotFound
  },
  {
    path: '/',
    component: Home,
    redirect: '/dataScreening',
    children: [
      // {
      //   path: '/home',
      //   component: Welcome,
      //   meta: { title: 'tabmenu.name1' },
      //   name: 'Home'
      // },

      {
        path: '/dataScreening',
        component: Welcome,
        name: 'Welcome',
        meta: { title: 'tabmenu.name48' },
        redirect: '/dataScreening',
        children: [
          {
            path: '/dataScreening',
            name: 'DataScreening',
            component: DataScreening,
            meta: { title: 'tabmenu.name49' }
          },
          {
            path: '/activateData',
            name: 'ActivateData',
            component: ActivateData,
            meta: { title: 'tabmenu.name50' }
          },
          {
            path: '/realTimeMonitoring',
            name: 'RealTimeMonitoring',
            component: RealTimeMonitoring,
            meta: { title: 'tabmenu.name56' }
          },
          {
            path: '/usage',
            name: 'Usage',
            component: Usage,
            meta: { title: 'tabmenu.name57' }
          },
          {
            path: '/faultStatistics',
            name: 'FaultStatistics',
            component: FaultStatistics,
            meta: { title: 'tabmenu.name58' }
          },
          {
            path: '/regionalDistribution',
            name: 'RegionalDistribution',
            component: RegionalDistribution,
            meta: { title: 'tabmenu.name59' }
          }
        ]
      },
      {
        path: '/dataSummary',
        component: Welcome,
        name: 'Welcome',
        meta: { title: 'tabmenu.name64' },
        redirect: '/dataSummary',
        children: [
          {
            path: '/dataSummary',
            name: 'DataSummary',
            component: DataSummary,
            meta: { title: 'tabmenu.name63' }
          },
          {
            path: '/appSituation',
            name: 'AppSituation',
            component: AppSituation,
            meta: { title: 'tabmenu.name65' }
          }
        ]
      },
      {
        path: '/systemNotification',
        component: SystemNotification,
        meta: { title: 'tabmenu.name33' },
        name: 'Home'
      },

      {
        path: '/setting',
        component: Setting,
        meta: { title: 'tabmenu.name34' },
        name: 'Home'
      },

      {
        path: '/simcardmanagement',
        component: Finance,
        name: 'Finance',
        meta: { title: 'tabmenu.name12' },
        redirect: '/simcardmanagement',
        children: [
          // {
          //   path: '/iotcharging',
          //   name: 'IotCharging',
          //   component: IotCharging,
          //   meta: { title: 'tabmenu.name13' }
          // },
          {
            path: '/simcardmanagement',
            name: 'SimCardManagement',
            component: SimCardManagement,
            meta: { title: 'tabmenu.name14' }
          },
          {
            path: '/order',
            name: 'Order',
            component: Order,
            meta: { title: 'tabmenu.name43' }
          }
        ]
      },
      {
        path: '/systemuserlist',
        component: User,
        name: 'User',
        meta: { title: 'tabmenu.name20' },
        redirect: '/systemuserlist',
        children: [
          {
            path: '/systemuserlist',
            name: 'SystemUserlist',
            component: SystemUserList,
            meta: { title: 'tabmenu.name21' }
          },
          {
            path: '/systemroleslist',
            name: 'SystemRolesList',
            component: SystemRolesList,
            meta: { title: 'tabmenu.name22' }
          },
          {
            path: '/permissionrulelist',
            name: 'PermissionRuleList',
            component: PermissionRuleList,
            meta: { title: 'tabmenu.name23' }
          },
          {
            path: '/purview',
            name: 'Purview',
            component: Purview,
            meta: { title: 'tabmenu.name35' }
          }
        ]
      },
      {
        path: '/manufacturerslist',
        component: User,
        name: 'User',
        meta: { title: 'tabmenu.name25' },
        redirect: '/manufacturerslist',
        children: [
          {
            path: '/manufacturerslist',
            name: 'ManufacturersList',
            component: ManufacturersList,
            meta: { title: 'tabmenu.name26' }
          },
          {
            path: '/manufactureruserlist',
            name: 'ManufacturerUserList',
            component: ManufacturerUserList,
            meta: { title: 'tabmenu.name27' }
          },
          {
            path: '/manufacturersroleslist',
            name: 'ManufacturersRoleslist',
            component: ManufacturersRoleslist,
            meta: { title: 'tabmenu.name36' }
          }
        ]
      },
      {
        path: '/merchantlist',
        component: User,
        name: 'User',
        meta: { title: 'tabmenu.name28' },
        redirect: '/merchantlist',
        children: [
          {
            path: '/merchantlist',
            name: 'MerchantList',
            component: MerchantList,
            meta: { title: 'tabmenu.name29' }
          },
          {
            path: '/merchantuserlist',
            name: 'MerchantUserList',
            component: MerchantUserList,
            meta: { title: 'tabmenu.name30' }
          },
          {
            path: '/merchantroleslist',
            name: 'MerchantRoleslist',
            component: MerchantRoleslist,
            meta: { title: 'tabmenu.name37' }
          },
          {
            path: '/franchiseeslist',
            name: 'FranchiseesList',
            component: FranchiseesList,
            meta: { title: 'tabmenu.name31' }
          },
          {
            path: '/franchiseesroleslist',
            name: 'FranchiseesRolesList',
            component: FranchiseesRolesList,
            meta: { title: 'tabmenu.name46' }
          },
          {
            path: '/franchiseesuserlist',
            name: 'FranchiseesUserList',
            component: FranchiseesUserList,
            meta: { title: 'tabmenu.name32' }
          }
        ]
      },
      {
        path: '/demoAccountManagement',
        component: User,
        name: 'User',
        meta: { title: 'tabmenu.name70' },
        redirect: '/demoAccountManagement',
        children: [
          {
            path: '/demoAccountManagement',
            name: 'DemoAccountManage',
            component: DemoAccountManage,
            meta: { title: 'tabmenu.name71' }
          },
          {
            path: '/customerServiceConfiguration',
            name: 'CustomerServiceConfiguration',
            component: CustomerServiceConfiguration,
            meta: { title: 'tabmenu.name72' }
          }
        ]
      },
      {
        path: '/logpagelist',
        component: User,
        name: 'User',
        meta: { title: 'tabmenu.name24' },
        redirect: '/logpagelist',
        children: [
          {
            path: '/logpagelist',
            name: 'Logpagelist',
            component: Logpagelist,
            meta: { title: 'tabmenu.name24' }
          }
        ]
      },
      {
        path: '/oatManagement',
        component: Bike,
        name: 'Bike',
        meta: { title: 'tabmenu.name3' },
        redirect: '/oatManagement',
        children: [
          {
            path: '/limitedUpgradeTool',
            name: 'LimitedUpgradeTool',
            component: LimitedUpgradeTool,
            meta: { title: 'tabmenu.name5' }
          },
          {
            path: '/oatManagement',
            name: 'OATManagement',
            component: OATManagement,
            meta: { title: 'tabmenu.name6' }
          },
          {
            path: '/firmware',
            name: 'Firmware',
            component: Firmware,
            meta: { title: 'tabmenu.name10' }
          },
          {
            path: '/batchupgrade',
            name: 'BatchUpgrade',
            component: BatchUpgrade,
            meta: { title: 'tabmenu.name55' }
          }
        ]
      },

      {
        path: '/bikelist',
        component: Bike,
        name: 'Bike',
        meta: { title: 'tabmenu.name7' },
        redirect: '/bikelist',
        children: [
          {
            path: '/bikelist',
            name: 'BikeList',
            component: BikeList,
            meta: { title: 'tabmenu.name8' }
          },
          {
            path: '/modellist',
            name: 'ModelList',
            component: ModelList,
            meta: { title: 'tabmenu.name9' }
          },
          {
            path: '/summaryModels',
            name: 'SummaryModels',
            component: SummaryModels,
            meta: { title: 'tabmenu.name67' }
          },
          {
            path: '/iotlist',
            name: 'IotList',
            component: IotList,
            meta: { title: 'tabmenu.name41' }
          },
          {
            path: '/faultmanagement',
            name: 'FaultManagement',
            component: FaultManagement,
            meta: { title: 'tabmenu.name11' }
          },
          {
            path: '/visualReport',
            name: 'VisualReport',
            component: VisualReport,
            meta: { title: 'tabmenu.name47' }
          },
          {
            path: '/debuggingReport',
            name: 'DebuggingReport',
            component: DebuggingReport,
            meta: { title: 'tabmenu.name4' }
          },
          {
            path: '/productCertificate',
            name: 'ProductCertificate',
            component: ProductCertificate,
            meta: { title: 'tabmenu.name66' }
          }
        ]
      },
      {
        path: '/cyclinglist',
        component: Bike,
        name: 'Bike',
        meta: { title: 'tabmenu.name40' },
        redirect: '/cyclinglist',
        children: [
          {
            path: '/cyclinglist',
            name: 'CyclingList',
            component: CyclingList,
            meta: { title: 'tabmenu.name38' }
          },

          {
            path: '/roadbooklist',
            name: 'RoadBookList',
            component: RoadBookList,
            meta: { title: 'tabmenu.name39' }
          }
        ]
      },
      {
        path: '/operate',
        component: Operate,
        name: 'Operate',
        meta: { title: 'tabmenu.name16' },
        redirect: '/overviewapplisting',
        children: [
          {
            path: '/overviewapplisting',
            name: 'OverviewAppListing',
            component: OverviewAppListing,
            meta: { title: 'tabmenu.name17' }
          },
          {
            path: '/overviewappusers',
            name: 'OverviewAppUsers',
            component: OverviewAppUsers,
            meta: { title: 'tabmenu.name18' }
          },
          {
            path: '/feedbacklist',
            name: 'FeedBackList',
            component: FeedBackList,
            meta: { title: 'tabmenu.name42' }
          },
          {
            path: '/pushlist',
            name: 'PushList',
            component: PushList,
            meta: { title: 'tabmenu.name45' }
          },
          {
            path: '/sysintroduction',
            name: 'SysIntroduction',
            component: SysIntroduction,
            meta: { title: 'tabmenu.name44' }
          },
          {
            path: '/appConfiguration',
            name: 'AppConfiguration',
            component: AppConfiguration,
            meta: { title: 'tabmenu.name60' }
          }
        ]
      },
      {
        path: '/operate',
        component: Operate,
        name: 'Operate',
        meta: { title: 'tabmenu.name53' },
        redirect: '/electronicfence',
        children: [
          {
            path: '/electronicfence',
            name: 'ElectronicFence',
            component: ElectronicFence,
            meta: { title: 'tabmenu.name52' }
          },
          {
            path: '/reconciliation',
            name: 'Reconciliation',
            component: Reconciliation,
            meta: { title: 'tabmenu.name54' }
          },
          {
            path: '/transactionRecord',
            name: 'TransactionRecord',
            component: TransactionRecord,
            meta: { title: 'tabmenu.name61' }
          },
          {
            path: '/refundRecord',
            name: 'RefundRecord',
            component: RefundRecord,
            meta: { title: 'tabmenu.name62' }
          },
          {
            path: '/maintenanceRecord',
            name: 'MaintenanceRecord',
            component: MaintenanceRecord,
            meta: { title: 'tabmenu.name68' }
          },
          {
            path: '/salesRecord',
            name: 'SalesRecord',
            component: SalesRecord,
            meta: { title: 'tabmenu.name69' }
          }
        ]
      }
    ]
  }
]
// 异步路由表
export const asyncRoutes = []
// 出错路由
export const anyRoutes = {
  path: '*',
  redirect: '/404',
  hidden: true
}

const createRouter = () =>
  new Router({
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
